import { Grid } from "@mui/material";
import FormField from "../molecule/FormField";
import { FieldType, FormButtonType } from "src/types/genericFrom.types";
import { LoadingButton } from "@mui/lab";
import UploadIcon from "@mui/icons-material/Upload";
import CheckIcon from "@mui/icons-material/Check";

type GenericFormPropsType = {
  state: any;
  setState: any;
  fields: FieldType[];
  buttons?: FormButtonType[];
  uploadButtons?: FormButtonType[];
};

export default function GenericForm({
  state,
  setState,
  fields,
  buttons,
  uploadButtons,
}: GenericFormPropsType) {
  const hasRequiredFiles = fields.find((field) =>
    field.props.required &&
    (state?.[field.name] === "" ||
      state?.[field.name] === null ||
      state?.[field.name] === undefined)
      ? false
      : true
  );

  const btnClickHandler = (button: FormButtonType) => {
    let result: any;
    if (button.checkRequiredField) {
      if (hasRequiredFiles && typeof button.onClick !== "undefined") {
        result = button.onClick();
      } else {
        result = undefined;
      }
    } else {
      if (typeof button.onClick !== "undefined") {
        result = button.onClick();
      }
    }
    return result;
  };

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => (
        <Grid
          xs={12}
          sm={field?.props?.width === "half" ? 6 : 12}
          item
          key={index}
          sx={{ display: field.props.display === false ? "none" : "" }}
        >
          <FormField
            setValue={(value: any) =>
              setState({
                ...state,
                [field.name]: value,
              })
            }
            value={(state as any)?.[field.name]}
            component={field.component}
            props={field.props}
          />
        </Grid>
      ))}
      {uploadButtons && uploadButtons!.length > 0 && (
        <Grid container item xs={12} justifyContent="flex-end" spacing={1}>
          {uploadButtons!.map((button, index) => {
            return (
              <Grid item key={index}>
                <LoadingButton
                  variant={button.variant}
                  color={button.isLoading ? "success" : button.color}
                  component="label"
                  startIcon={button.isLoading ? <CheckIcon /> : <UploadIcon />}
                >
                  {button.text}
                  <input
                    type="file"
                    hidden
                    onChange={(e) => {
                      if (typeof button.onChange !== "undefined") {
                        button.onChange(e.target.files![0]);
                      }
                    }}
                  />
                </LoadingButton>
              </Grid>
            );
          })}
        </Grid>
      )}
      {buttons!.length > 0 && (
        <Grid container item xs={12} justifyContent="flex-end" spacing={1}>
          {buttons!.map((button, index) => (
            <Grid item key={index}>
              <LoadingButton
                loading={button.isLoading}
                onClick={() => btnClickHandler(button)}
                variant={button.variant}
                color={button.color}
                disabled={!!button.isLoading}
              >
                {button.text}
              </LoadingButton>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
}
